
let widthProduct = undefined;
let widthContainer = undefined;
let widthWrapper = undefined;
let numVisible = undefined;
let numProducts = undefined;
let busy = undefined;
let windowWidth = undefined;
let check_arrows = undefined;

export default class Product {
	static initClass() {
		widthProduct = 190;
		widthContainer = $('.product-page-products').outerWidth();
		widthWrapper = $('.product-page-products-wrapper').outerWidth();
		numVisible = widthWrapper / widthProduct;
		numProducts = $('.product-page-products__item').length;
		busy = false;

		windowWidth = $(window).outerWidth();

		check_arrows = function (margin) {
			if (margin == null) { margin = 0; }
			if (numProducts > numVisible) {
				$('.js-product-arrow').removeClass('is-disabled');
			}

			if ((margin === 0) || (numProducts < numVisible)) {
				$('.js-product-arrow.is-left').addClass('is-disabled');
			}

			if ((margin === -((numProducts - numVisible) * widthProduct)) || (numProducts < numVisible)) {
				return $('.js-product-arrow.is-right').addClass('is-disabled');
			}
		};
	}

	constructor() {
		this.initEvents();

		if ($('html').hasClass('ie9')) {
			$('.product-page-copy').columnize({ columns: 2 });
		}
	}

	initEvents() {
		check_arrows();
		if (numProducts > numVisible) {
			$('.product-page-products').css('margin-left', '0px');
		}

		//window resize event
		$(window).on('resize', this.update_slider);
		//click event for slider arrows
		$('.js-product-arrow').on('click', this.switch_product);

		//click event on product image
		return $('.product-page-products__item a').on('click', this.switch_nutri_info);
	}

	update_slider(e) {
		let margin;
		widthContainer = $('.product-page-products').outerWidth();
		numVisible = $('.product-page-products-wrapper').outerWidth() / widthProduct;

		if (numProducts < numVisible) {
			margin = 'auto';
		} else {
			margin = 0;
		}

		$('.product-page-products').css('margin-left', margin);
		return check_arrows(0);
	}

	switch_product(e) {
		e.preventDefault();

		if (!busy) {
			busy = true;

			window.setTimeout(() => busy = false
				, 500);

			let margin = parseInt($('.product-page-products').css('margin-left'), 10);

			if ($(this).hasClass('is-right')) {
				margin -= widthProduct;
			}

			if ($(this).hasClass('is-left')) {
				margin += widthProduct;
			}

			$('.product-page-products').css('margin-left', margin);
			return check_arrows(margin);
		}
	}

	switch_nutri_info(e) {
		e.preventDefault();
		$('.product-page-products__item').removeClass('is-active');
		const parent = $(this).parent();
		parent.addClass('is-active');
		/*parentIndex = parent.index()*/

		$.ajaxSetup({ headers: { 'X-CSRF-Token': $('input[name="_token"]').val() } });

		const url = window.site.base_url + '/api/nutritionalvalue';
		return $.post(url, {
			language: window.site.lang,
			package_id: $(this).attr('data-id')
		},
			function (data) {
				$('.product-page-content .nutri-info').remove();
				return $('.product-page-content').append(data);
			});
	}
}